import React from 'react'

import { Card } from 'antd'
import PT from 'prop-types'

const FunctionalityContainer = props => {
  const { children, title } = props
  return (
    <Card
      bodyStyle={{ paddingTop: 8 }}
      title={
        <h2 style={{ display: 'inline', fontSize: 'inherit', fontWeight: 'inherit', margin: 0 }}>
          {title}
        </h2>
      }
    >
      {children}
    </Card>
  )
}

FunctionalityContainer.propTypes = {
  title: PT.string.isRequired,
}

export default FunctionalityContainer
